<template>
    <div class="rateContainer">
        <div v-if="!rated" class="cont">
            <div class="md-title" style="font-size: 15px; font-weight: 550; color: var(--color7)">
                {{ $t("message.feedbackImportant") }}
            </div>
            <div class="d-flex conversation-bubble speech">
                <div class="d-flex align-items-center justify-content-center" style="width: 60px">
                    <a-avatar
                        :size="50"
                        :src="getAgentImage()"
                        :username="participants.length > 0 && !!participants[0].gravatar ? null : agentName()"
                        class="agent-avatar"
                        style="font-size: 25px; margin: initial"
                        >{{
                            participants.length > 0 && !!participants[0].gravatar
                                ? null
                                : agentName().substr(0, 1).toUpperCase()
                        }}
                    </a-avatar>
                </div>
                <div
                    class="d-flex justify-content-center align-items-center flex-column"
                    style="width: calc(100% - 60px)"
                >
                    <div class="justify-content-center align-items-center">
                        <a-rate
                            v-model="rating"
                            :star-points="[23, 2, 14, 17, 0, 19, 10, 34, 7, 50, 23, 43, 38, 50, 36, 34, 46, 19, 31, 17]"
                            :star-size="25"
                            :tooltips="desc"
                        />
                    </div>
                    <div
                        class="justify-content-center align-items-center helpText"
                        style="opacity: unset; font-weight: 600"
                    >
                        {{
                            $t("message.isHelp", {
                                userAgent: startCase(agentName()),
                            })
                        }}
                    </div>
                </div>
            </div>
            <div>
                <textarea
                    v-model="description"
                    :placeholder="$t('message.descriptionPlaceHolder')"
                    class="txtDesc"
                    rows="3"
                ></textarea>
            </div>
            <div class="d-flex align-items-center justify-content-end">
                <a-button class="send-button" type="primary" @click="rate">
                    <md-icon style="transform: rotate(-30deg); font-size: 21px !important">send</md-icon>
                </a-button>
            </div>
        </div>
        <div
            v-if="rated"
            style="
                background: #368dda;
                color: #fff;
                padding: 1rem;
                border-radius: 1rem;
                font-size: 1rem;
                margin-left: 15px;
            "
        >
            <span>{{ $t("message.feedbackThanksMessage") }}</span>
        </div>
        <div class="cont mt-3" v-if="showAfterActions && (!connected || isChatbotActive)">
            <md-button class="feedback-actions" @click="reconnect">{{ $t("message.startChatAgain") }}</md-button>
            <textarea
                ref="mailInput"
                rows="1"
                v-model="transcriptMail"
                :placeholder="$t('message.email')"
                class="transcriptinput"
            />
            <md-button
                :disabled="loading || transcriptIsSent"
                class="feedback-actions"
                size="small"
                style="margin-top: 6px"
                @click="startSendTranscript"
            >
                {{
                    sendTranscriptCount === 0
                        ? $t("message.transcriptSent")
                        : loading
                        ? $t("message.transcriptSending")
                        : sendTranscriptCount > 0 && sendTranscriptCount < 3
                        ? $t("message.sendAgainTranscript")
                        : $t("message.sendTranscript")
                }}
            </md-button>
        </div>
        <div v-else>
            <md-progress-spinner md-mode="indeterminate" style="color: var(--color7)" class="loadMoreSpinner" />
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import ChatOkey from "../svg/ChatOkey";
import * as _ from "lodash";
import { log2 } from "../../utils/log2";
import { sessionId } from "../../utils/session";
import { sendSocketMessage } from "../../utils/socketStream";
import version from "../../utils/version";
import { sendTranscript } from "../../api/chat";
import { publishMessage, SystemMessageTypes } from "../../utils/systemPubSub";
import { getPersistenceData } from "../../utils/persistenceStorage";
import { CONFIG } from "../../utils/config";

const log = log2("Rate");
export default {
    name: "Rate",
    props: {
        agent: {
            type: String,
        },
        avatarUrl: {
            type: String,
        },
        participants: {
            type: Array,
        },
    },
    data() {
        return {
            loading: false,
            rating: 5,
            rated: false,
            description: "",
            transcriptIsSent: false,
            shouldShow: false,
            sendTranscriptCount: 3,
            desc: [
                this.$t("message.terrible"),
                this.$t("message.bad"),
                this.$t("message.normal"),
                this.$t("message.good"),
                this.$t("message.wonderful"),
            ],
            transcriptMail: !!JSON.parse(getPersistenceData("lastLoginData", null))
                ? JSON.parse(getPersistenceData("lastLoginData", null)).email
                : "",
        };
    },
    computed: {
        ...mapState({
            showAfterActions: (state) => state.app.showAfterActions,
            connected: (state) => state.chat.connected,
            isChatbotActive: (state) => state.chat.isChatbotActive,
            visitorId: (state) => state.chat.visitorId,
            conversationId: (state) => state.chat.lastConversationId,
            site: (state) => state.site.site,
            preDefinedUserData: (state) => state.chat.preDefinedUserData,
            settings: (state) => state.setting.settings,
        }),
        lodash: _,
    },
    components: {
        ChatOkey,
    },
    mounted() {
        log("mounted", {
            agent: this.agent,
            avatarUrl: this.avatarUrl,
            participants: this.participants,
        });
        this.shouldShow = true;
        this.fillEmail();
    },
    updated() {
        log("updated", {
            agent: this.agent,
            avatarUrl: this.avatarUrl,
            participants: this.participants,
        });
    },
    methods: {
        ...mapActions({
            resetConversation: "chat/resetConversation",
            toggleAfterActions: "app/toggleAfterActions",
            toggleRating: "app/toggleRating",
        }),
        fillEmail() {
            let lastLoginData = JSON.parse(getPersistenceData("lastLoginData", null));
            let lastCustomLogins = JSON.parse(getPersistenceData("lastCustomLogins", null));
            let transMail;
            if (this.preDefinedUserData.initialized && !!this.preDefinedUserData.email) {
                transMail = this.preDefinedUserData.email;
            } else {
                if (!!lastLoginData && !!lastLoginData.email) {
                    transMail = lastLoginData.email;
                } else {
                    if (!!lastCustomLogins && !!lastCustomLogins[0].email) {
                        transMail = lastCustomLogins[0].email;
                    } else {
                        transMail = "";
                    }
                }
            }
            this.transcriptMail = transMail;
        },

        startSendTranscript() {
            log("startSendTranscript başladı");
            let regex = new RegExp("[a-z0-9]+@[a-z]+\.[a-z]{2,3}");
            if (!regex.test(this.transcriptMail)) {
                this.$message.error(this.$t("message.visitorEmailIsNotValid"));
                return this.$refs.mailInput.classList.add("not-correct");
            }
            this.$refs.mailInput.classList.remove("not-correct");

            this.loading = true;

            sendTranscript(this.conversationId, this.transcriptMail)
                .then((x) => {
                    this.loading = false;
                    log("respons başarılı");
                    this.$message.success(this.$t("message.transcriptSent"));
                    this.sendTranscriptCount -= 1;
                    if (this.sendTranscriptCount === 0) {
                        this.transcriptIsSent = true;
                    }
                })
                .catch((err) => {
                    console.error(err);
                    this.loading = false;
                });
        },
        rate(rating) {
            log("rating", rating);
            let desc = this.description;
            if (this.isEmpty(desc)) {
                desc = null;
            }
            sendSocketMessage("visitor rating", {
                visitorId: this.visitorId,
                conversationId: this.conversationId,
                point: this.rating,
                description: desc,
                siteId: this.site._id,
            });
            /*this.toggleAfterActions();*/
            this.rated = true;
        },
        isEmpty(str) {
            return !str || 0 === str.length;
        },
        connect() {
            sendSocketMessage("visitor connect", {
                visitorId: this.visitorId,
                conversationId: this.conversationId,
                siteId: this.site._id,
                sessionId,
                version,
            });
            if (this.settings.visitorAutoLogin) {
                publishMessage("AUTO_LOGIN", { initialMessage: "", loginData: {} });
            }
        },
        reconnect() {
            this.toggleRating(false);
            this.toggleAfterActions(false);
            this.resetConversation();
            publishMessage(SystemMessageTypes.RESTART_NEEDED, {});
            this.connect();
        },
        agentName() {
            return this.participants.length ? this.participants[0].name : this.$t("message.representative");
        },
        isChatbot() {
            return _.get(this.participants, "[0]._id") === "chatbot";
        },
        getChatbotImage() {
            return _.get(CONFIG.CHATBOT_IMAGES, this.site._id) || CONFIG.CHATBOT_IMAGES.default;
        },
        getAgentImage() {
            if (this.isChatbot()) {
                return this.getChatbotImage();
            } else {
                return this.participants.length > 0 && !!this.participants[0].gravatar
                    ? this.participants[0].gravatar
                    : null;
            }
        },
        startCase(str) {
            return _.startCase(str.trim().toLowerCase());
        },
    },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/V2/Rate.vue